export const USERS_FETCH_TYPES = {
  userOrganization: 'user_organization',
  contentCenter: 'content_center'
}